import React from 'react';

function Welcome({ onNext }) {
  return (
    <div className="card fade-in" style={{ maxWidth: '700px', margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h1 style={{ marginBottom: '1rem' }}>Welcome to ST Books</h1>
        <p style={{ fontSize: '1.125rem', color: 'var(--text-secondary)' }}>
          Let's get you set up! This onboarding will take approximately 10-15 minutes.
        </p>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>What you'll need:</h3>
        <ul style={{ paddingLeft: '1.5rem', lineHeight: '2', listStyleType: 'disc' }}>
          <li style={{ display: 'list-item' }}>Business details (ABN, business name, contact information)</li>
          <li style={{ display: 'list-item' }}>Service requirements and preferences</li>
          <li style={{ display: 'list-item' }}>Driver's licence (front and back)</li>
          <li style={{ display: 'list-item' }}>A clear photo of yourself holding your licence</li>
          <li style={{ display: 'list-item' }}>Approximately 10 minutes to complete the forms</li>
        </ul>
      </div>

      <div className="alert alert-info" style={{ marginBottom: '2rem' }}>
        <strong>Privacy & Security</strong>
        <p style={{ margin: '0.5rem 0 0 0' }}>
          Your information is encrypted and securely stored. We comply with Australian privacy laws and ATO requirements.
        </p>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>What happens next:</h3>
        <ol style={{ paddingLeft: '1.5rem', lineHeight: '2', listStyleType: 'decimal' }}>
          <li style={{ display: 'list-item' }}>Complete your business and contact information</li>
          <li style={{ display: 'list-item' }}>Upload your ID verification documents</li>
          <li style={{ display: 'list-item' }}>Review and sign the Client Agreement and BAS Agent Authority</li>
          <li style={{ display: 'list-item' }}>Receive your Confirmation email with next steps</li>
        </ol>
      </div>

      <div className="alert alert-warning">
        <strong>Important</strong>
        <p style={{ margin: '0.5rem 0 0 0' }}>
          You can save your progress and return later using this same link. The link will remain active for 7 days.
        </p>
      </div>

      <button 
        className="btn btn-primary w-full"
        data-testid="start-button"
        onClick={() => onNext({})}
        style={{ marginTop: '2rem', padding: '1rem', fontSize: '1.125rem' }}
      >
        Get Started
      </button>
    </div>
  );
}

export default Welcome;